import React, { useState } from 'react';
import classNames from 'classnames';
import { Text } from '@gje/typography/lib';
import posed, { PoseGroup } from 'react-pose';
import { HtmlPanel } from '../HtmlPanel/HtmlPanel';
import uuid from 'uuid';
import useMobile from '../../../hooks/useMobile';

export const ExpandableBulletText = ({
    text,
    helpText,
    className = '',
    arrowSize
}) => {
    //@ts-ignore
    const [isOpen, setOpen] = useState(false);

    const isMobile = useMobile();

    const handleCoverHelpClick = () => {
        setOpen(!isOpen);
    };

    const ExtraCoverHelpBox = posed.div({
        exit: {
            height: 0,
            opacity: 0,
            transition: {
                ease: 'easeIn',
                duration: 0
            }
        },
        enter: {
            opacity: 1,
            height: 'auto',
            transition: {
                ease: 'easeIn',
                duration: 300
            }
        }
    });

    return (
        <div className={'word-break-word'}>
            <a
                className={classNames('no-underline', { green: isOpen })}
                onClick={() => handleCoverHelpClick()}>
                <div className={'col-xs-2'}>
                    <Text
                        size={'h5'}
                        className={classNames(
                            'arrow-color',
                            'margin-right-8',
                            isMobile ? 'margin-top-3' : 'margin-top-4'
                        )}>
                        <div
                            style={{
                                fontSize: arrowSize
                            }}>
                            {isOpen ? <>&#9650;</> : <>&#9660;</>}
                        </div>
                    </Text>
                </div>
                <div className={'col-xs-21'}>
                    <Text
                        size={'h5'}
                        className={classNames(
                            `${className}`,
                            'text-align-left',
                            'green-on-hover'
                        )}>
                        <HtmlPanel>{text}</HtmlPanel>
                    </Text>
                </div>
            </a>
            <div className="text-align-left">
                <div>
                    <div className={'col-xs-2'} />
                    <div className={'col-xs-21'}>
                        <PoseGroup>
                            {isOpen && [
                                <ExtraCoverHelpBox
                                    key={`extraCoverHelpBox-${uuid.v4()}`}>
                                    <Text
                                        className={`margin-top-13 margin-bottom-13`}>
                                        <HtmlPanel>{helpText}</HtmlPanel>
                                    </Text>
                                </ExtraCoverHelpBox>
                            ]}
                        </PoseGroup>
                    </div>
                </div>
            </div>
        </div>
    );
};
